/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2019, Zumper
 * @description   Detail monetized similar listings actions
 */

import type { Listable } from '@zcode/state-type'
import { createAction } from 'redux-actions'

import {
  CLEAR_MONETIZED_SIMILAR_LISTINGS,
  DONE_FETCHING_MONETIZED_SIMILAR_LISTINGS,
  ERROR_FETCHING_MONETIZED_SIMILAR_LISTINGS,
  RECEIVE_MONETIZED_SIMILAR_LISTINGS,
  START_FETCHING_MONETIZED_SIMILAR_LISTINGS,
} from '../constants/index'

export const startFetchingMonetizedSimilarListings = createAction<
  { key: string },
  typeof START_FETCHING_MONETIZED_SIMILAR_LISTINGS
>(START_FETCHING_MONETIZED_SIMILAR_LISTINGS)
export const clearMonetizedSimilarListings = createAction(CLEAR_MONETIZED_SIMILAR_LISTINGS)
export const doneFetchingMonetizedSimilarListings = createAction(
  DONE_FETCHING_MONETIZED_SIMILAR_LISTINGS
)
export const errorFetchingMonetizedSimilarListings = createAction<
  { error: unknown },
  typeof ERROR_FETCHING_MONETIZED_SIMILAR_LISTINGS
>(ERROR_FETCHING_MONETIZED_SIMILAR_LISTINGS)
export const receiveMonetizedSimilarListings = createAction<
  { key: string; monetizedSimilarListings: readonly Listable[] },
  typeof RECEIVE_MONETIZED_SIMILAR_LISTINGS
>(RECEIVE_MONETIZED_SIMILAR_LISTINGS)
